import Rest from '../Rest'

export default class FeePlanVersionService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/fee_plan_versions'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  publish(versionId: number, data: any = {}) {
    return this.post(`/${versionId}/publish`, data)
  }
}
